<!-- text-fragment.component.html -->
<div class="text-fragment-container" *ngIf="processedLines && processedLines.length > 0">
 <div class="fragment-lines">
      <div *ngFor="let line of processedLines; trackBy: trackByLineNumber" class="line-container">
        <span class="line-number">{{ line.lineNumber }}</span>
        <span 
          [class]="getLineClasses(line)"
          [innerHTML]="renderLineWithAttributes(line)">
        </span>
      </div>
    </div>
  </div>
  
  <div class="no-data" *ngIf="!processedLines || processedLines.length === 0">
    <p>{{'iaa.app.fragment.noTexts' | translate}}</p>
  </div>